import { ServiceResponse } from "../ServiceResponse";

export class DeletePageStatusResponse extends ServiceResponse {
  public DeleteSuccess: boolean = false;
}
